let conf;
const setConfig = (next) => {
  conf = next;
  configListeners.forEach((cb) => cb(next));
};
const setConfigFont = (name, font, fontParsed) => {
  if (process.env.NODE_ENV === "development") {
    if (!conf)
      throw new Error(`Haven't called createTamagui yet`);
  }
  conf.fonts[name] = font;
  conf.fontsParsed[`$${name}`] = fontParsed;
};
const getConfig = () => {
  if (!conf) {
    throw new Error(
      process.env.NODE_ENV !== "production" ? `Missing tamagui config, you either have a duplicate config, or haven't set it up. Be sure createTamagui is called before rendering.` : "Err0"
    );
  }
  return conf;
};
let cached;
const getTokens = ({
  prefixed
} = {}) => {
  if (process.env.NODE_ENV === "development") {
    if (!conf)
      throw new Error(`Haven't called createTamagui yet`);
  }
  const { tokens, tokensParsed } = conf;
  if (prefixed === false)
    return tokens;
  if (prefixed === true)
    return tokensParsed;
  if (cached)
    return cached;
  cached = Object.fromEntries(
    Object.entries(tokens).map(([k, v]) => [k, { ...v, ...tokensParsed[k] }])
  );
  return cached;
};
const useTokens = () => getTokens();
const getThemes = () => conf.themes;
const configListeners = /* @__PURE__ */ new Set();
const onConfiguredOnce = (cb) => {
  if (conf) {
    cb(conf);
  } else {
    configListeners.add(cb);
  }
};
const updateConfig = (key, value) => {
  Object.assign(conf[key], value);
};
const getFont = (name) => {
  var _a;
  const conf2 = getConfig();
  return conf2.fontsParsed[name] ?? ((_a = Object.entries(conf2.fontsParsed).find(
    ([k]) => {
      var _a2, _b;
      return ((_b = (_a2 = conf2.fontsParsed[k]) == null ? void 0 : _a2.family) == null ? void 0 : _b["val"]) === name;
    }
  )) == null ? void 0 : _a[1]);
};
export {
  configListeners,
  getConfig,
  getFont,
  getThemes,
  getTokens,
  onConfiguredOnce,
  setConfig,
  setConfigFont,
  updateConfig,
  useTokens
};
//# sourceMappingURL=config.js.map
